import React from 'react'
import { useTranslation } from 'react-i18next'

import FrequencyFields from './FrequencyFields'

import useDrawerFormClasses from '../../../../../../../../../styles/common/drawerForms'

const FrequencyCapSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  return (
    <section className={drawerFormClasses.section}>
      <h4 className={drawerFormClasses.sectionTitle}>{t('Frequency cap')}</h4>
      <p>{t('Impose frequency cap on creatives for this line item.')}</p>
      <br />
      <FrequencyFields formik={formik} />
    </section>
  )
}

export default FrequencyCapSection
